import { useAuth } from '@/contexts/AuthContext';
import type { PageMeta } from '@/lib/navigation';

interface HeaderProps {
  meta: PageMeta;
  onMenuClick: () => void;
}

export default function Header({ meta, onMenuClick }: HeaderProps) {
  const { profile, isSuperUsuario } = useAuth();

  const today = new Date().toLocaleDateString('es-BO', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-background-200 bg-background-50/90 px-4 backdrop-blur md:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Abrir menú"
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 lg:hidden"
      >
        <i className="ri-menu-line text-xl"></i>
      </button>

      <div className="min-w-0 flex-1">
        <h1 className="truncate font-heading text-base font-bold leading-tight text-foreground-950 md:text-lg">
          {meta.title}
        </h1>
        <p className="truncate text-xs text-foreground-500">{meta.subtitle}</p>
      </div>

      <p className="hidden text-xs capitalize text-foreground-500 xl:block">{today}</p>

      <div className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-1.5 md:flex">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-100 text-accent-700">
          <i className="ri-user-line text-sm"></i>
        </span>
        <div className="leading-tight">
          <p className="max-w-[140px] truncate text-xs font-semibold text-foreground-900">
            {profile?.full_name || profile?.username || 'Usuario'}
          </p>
          <p className="text-[10px] text-foreground-500">
            {isSuperUsuario ? 'Super usuario' : 'Usuario'}
          </p>
        </div>
      </div>
    </header>
  );
}